(function () {

  function animateCounter(counter) {
    const target = parseInt(counter.dataset.target, 10);
    if (!target || counter.dataset.animated === 'true') return;

    counter.dataset.animated = 'true';

    const duration = 1200; // ms
    const startTime = performance.now();
    const locale = document.documentElement.lang || 'hu-HU';

    function update(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const value = Math.floor(progress * target);

      counter.textContent = value.toLocaleString(locale);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counter.textContent = target.toLocaleString(locale) + '+';
      }
    }

    requestAnimationFrame(update);
  }

  function initCounters() {
    const counters = document.querySelectorAll('.js-counter');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });

    counters.forEach(counter => {
      counter.textContent = '0';
      observer.observe(counter);
    });
  }

  document.addEventListener('DOMContentLoaded', initCounters);
  document.addEventListener('shopify:section:load', initCounters);

})();
